import api from '../config/axiosConfig';
import {getStoredUser} from '../utils/apiResponseUtils';
const id = encodeURIComponent;
async function request(method, url, data, key) {
    const owner=getStoredUser();const commerceOwner=owner?.id??owner?.customerId??owner?.userId;
    const response = await api.request({ method, url,...(commerceOwner!==undefined?{commerceOwner:String(commerceOwner)}:{}), ...(data !== undefined ? { data } : {}), ...(key ? { headers: { 'Idempotency-Key': key } } : {}) });
    const envelope = response.data;
    if (envelope?.success === false) {
        const error = new Error(envelope.message || 'Request failed');
        error.response = response;
        throw error;
    }
    if (!envelope || envelope.success !== true)
        throw new Error('Unable to confirm the server response. Check the existing operation before retrying.');
    return envelope.data;
}
/** @type {import('../types/commerce').CommerceApi} */
export const commerce = {
    policy: async () => {
        const policy = await request('get', '/payment/policy');
        if (!policy || typeof policy.version !== 'string' || !policy.version.trim() || !['walletTerms', 'fareTerms', 'refundTerms'].every(key => Array.isArray(policy[key]) && policy[key].every(value => typeof value === 'string')) || !['minTopUp', 'maxTopUp', 'maxWalletBalance'].every(key => Number.isSafeInteger(policy[key]) && policy[key] >= 0) || typeof policy.topUpEnabled !== 'boolean' || typeof policy.supportEmail !== 'string')
            throw new Error('Payment terms are unavailable. Please refresh.');
        return policy;
    },
    quote: body => request('post', '/payment/quotes', body),
    checkout: (body, key) => request('post', '/payment/checkouts', body, key),
    checkoutStatus: value => request('get', `/payment/checkouts/${id(value)}`),
    verifyCheckout: (value, body, key) => request('post', `/payment/checkouts/${id(value)}/verify`, body, key),
    wallet: () => request('get', '/payment/wallet'),
    transactions: page => request('get', `/payment/wallet/transactions?page=${page}&size=20`),
    topUp: (body, key) => request('post', '/payment/wallet/top-ups', body, key),
    topUpStatus: value => request('get', `/payment/wallet/top-ups/${id(value)}`),
    verifyTopUp: (value, body, key) => request('post', `/payment/wallet/top-ups/${id(value)}/verify`, body, key),
    finance: value => request('get', `/payment/deliveries/${id(value)}`),
    cancellationQuote: value => request('post', `/payment/deliveries/${id(value)}/cancellation-quote`),
    cancel: (value, body, key) => request('post', `/payment/deliveries/${id(value)}/cancel`, body, key),
    refund: (value, body, key) => request('post', `/payment/deliveries/${id(value)}/refunds`, body, key),
    refundDocuments: (value, body) => request('post', `/payment/refunds/${id(value)}/documents`, body),
    closurePreview: () => request('get', '/account/closure-preview'),
    close: async (body, key) => {
        const result=await request('delete','/account',body,key);
        if(result?.closed!==true)throw new Error('Account closure is not confirmed. Check the existing closure request.');
        return result;
    },
};
